import React, { useEffect, useState } from "react";
import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";

import { ChatSection } from "../utils/home/chat-section";
import { UserProfile } from "../utils/home/user-profile";
import { assetIcons, assetImages } from "../../constants/assets";
import { useNavigate, useSearchParams } from "react-router-dom";
import { fontSizes } from "../../theme/font-sizes";
import { darkColors } from "../../theme/colors";

import ImageBox from "../utils/community/image-box";
import routes from "../../constants/routes";
import MatchFinder from "../utils/finding-match-timer";
import apiRoutes from "../../api/routes";
import useApiRequest from "../../api/api";
import { Category } from "../utils/community/tutorial-card";
import ArticleSkeleton from "./article-skeleton";
import InlineSvg from "../utils/inline-svg";

export default function ArticleComponent() {
  const navigate = useNavigate();
  const theme = useTheme();
  const { makeApiCall } = useApiRequest();
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleNavigateToRace = (id) => {
    navigate(`${routes.race}?id=${id}`);
    // Perform navigation or additional logic if required
  };
  const [data, setData] = useState([]);

  const fetchNews = async () => {
    setIsLoading(true);

    try {
      const response = await makeApiCall(apiRoutes.community.get(id), "GET");
      if (response?.data) {
        // Transform the single object into the desired format
        const fetchedArticle = {
          id: response.data.identifier, // Use unique identifier from API
          category: response.data.tag,
          title: response.data.title,
          description: response.data.description,
          content: response.data.content,
          image: response.data.coverImage,
        };

        // Update state with the transformed object
        setData(fetchedArticle); // Wrap in an array if the state expects an array
      }
    } catch (error) {
      console.error("Failed to fetch races:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);
  const navigateToCommunity = () => {
    navigate(routes.community);
  };
  return (
    <>
      {isLoading ? (
        <ArticleSkeleton isMediumScreen={isMediumScreen} />
      ) : (
        <Box
          sx={{
            display: "flex",
            height: "100vh",
          }}
        >
          {/* Left side - scrollable content */}
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              m: isMediumScreen ? 3.5 : "15px",
              mt: 0,
              pt: 6,
              ml: isMediumScreen ? 3.5 : "38px",
              borderRadius: "12px",
              mb: 2,
              "&::-webkit-scrollbar": {
                display: "none", // Hide scrollbar in WebKit browsers (Chrome, Safari)
              },
            }}
          >
            <Stack
              onClick={navigateToCommunity}
              direction={"row"}
              sx={{ cursor: "pointer" }}
              alignItems="center"
            >
              <InlineSvg
                sx={{
                  cursor: "pointer",
                  display: "inline-block",
                  width: 20,
                  mr: 3,
                  pb: 4,
                }}
                url={assetIcons.leftArrow}
              />
              <Typography
                fontFamily={"MontserratBold"}
                component="span"
                fontSize={
                  isMediumScreen ? fontSizes.heading2 : fontSizes.superHeading5
                }
                textAlign={"left"}
                color="white"
                sx={{ mb: isMediumScreen ? 4 : 4 }}
                // onClick={(e) => e.stopPropagation()}
              >
                Back to News
              </Typography>{" "}
            </Stack>
            <ImageBox
              isMediumScreen={isMediumScreen}
              assetImages={data?.image}
              isSmallScreen={isSmallScreen}
            ></ImageBox>

            {/* Profile Section */}
            <Box
              sx={{
                display: "flex",
                // flexDirection: "column",
                justifyContent: "start",
                alignItems: "center",

                mb: 4,
                // ml: isMediumScreen ? 3 : 7,
                textAlign: "left",
              }}
            >
              <Typography
                fontFamily={"MontserratBold"}
                fontSize={fontSizes.heading2}
                sx={{ mt: 2, color: "white" }}
              >
                {data?.title}
              </Typography>
              <Box
                sx={{
                  background: darkColors.navbarBlack,
                  width: 110,
                  // px: 2,
                  mt: 2,
                  py: 1,
                  ml: 4,
                  borderRadius: 99,
                }}
              >
                <Category fontSize={fontSizes.body} sx={{ fontWeight: 700 }}>
                  {data?.category}
                </Category>
              </Box>
            </Box>
            <Box mb={28}>
              <Typography
                color="white"
                textAlign="left"
                dangerouslySetInnerHTML={{ __html: data?.content || "" }}
              />
            </Box>
          </Box>

          {/* Right side - fixed content */}
          {!isMediumScreen && (
            <Box
              sx={{
                width: { lg: 370, sm: 300 },
                p: 3,
                height: "auto",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none", // Hide scrollbar in WebKit browsers (Chrome, Safari)
                },
              }}
            >
              <UserProfile
                username="@ExHuma64"
                avatarSrc="/placeholder.svg?height=40&width=40"
                balance={231}
              />
              <Box mt={3}></Box>
              <ChatSection />

              {/* Find Random Match Button */}
              <Box
                display={"flex"}
                justifyContent={"left"}
                mt={2}
                sx={{ mb: 11 }}
              >
                <MatchFinder
                  onNavigate={handleNavigateToRace} // Custom navigation logic
                />
              </Box>
            </Box>
          )}
        </Box>
      )}
    </>
  );
}
